var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var appEwinConstant = "app-ewin/home/";
var configURL = {
    market: {
        status: config.jmw + config.jmw_content + "bull",
        root: config.web_mw + "Market/Process/",
        market: config.web_mw + "Market/",
    },
    streamUrl: config.streamUrl,
    home: config.jmw + config.jmw_market_env + appEwinConstant,
    newOnEdel: config.jmw + config.jmw_market_env + appEwinConstant + "new-on-edel",
    liveNewsUrl: config.jmw + config.jmw_content + "liveNews/general",
    liveNewsNFOUrl: config.jmw + config.jmw_content + "liveNews",
    marketNewsUrl: config.jmw + config.jmw_news_content + "news/trendlyne/allNews",
    appid: config.appId,
    rootUrl: config.rootUrl,
    equityHoldingLiveNews: config.jmw + config.eqedel + "news/eqholdings",
    eVoting: config.jmw + config.jmw_content + "evoting/request"
};
var urlConfig = __assign({}, configURL);
export default urlConfig;
